import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { showError } from "../../../../util/ShowStatus";
import axios from "../../../../util/axiosconfig";

export const fetchAllConfinedSpacesEquipmentChecklistForm = async (
  setConfinedSpacesEquipmentChecklistForm: any,
  setConfinedSpacesEquipmentChecklistFormLoading: any,
  filters: any,
  toast: any,
  userIDs?: any
) => {
  try {
    const params: any = {};
    if (filters && filters.startDate && filters.endDate) {
      // Convert to UTC ISO string
      params.startDate = filters.startDate;
      params.endDate = filters.endDate;
      if (userIDs && userIDs.length > 0) {
        params.userIDs = userIDs.join(",");
      }
    }
    setConfinedSpacesEquipmentChecklistFormLoading(true);
    const response = await axios.get(
      `health-and-safety/pre-use-confined-space-equipment-form-list`,
      {
        params,
      }
    );
    setConfinedSpacesEquipmentChecklistForm(response.data.result);
    setConfinedSpacesEquipmentChecklistFormLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setConfinedSpacesEquipmentChecklistFormLoading(false);
    showError(error, toast);
  }
};

export const getFormByFormID = async (
  setFormData: any,
  setFormDataLoading: any,
  formIDParam: number,
  navigate: any,
  toast: any
) => {
  try {
    setFormDataLoading(true);
    const response = await axios.get(
      `health-and-safety/pre-use-confined-space-equipment-form-by-id?formID=${formIDParam}`
    );
    if (response.data.result.length === 0) {
      showError("Form not found", toast);
      setFormDataLoading(false);
      navigate("/layout/health-and-safety/pre-use-confined-space-equipment");
      return;
    }
    setFormData(response.data.result);
    setFormDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setFormDataLoading(false);
    showError(error, toast);
  }
};
